import Warning from '../component/warning';
import { connect } from 'react-redux';
import { getWarning } from '../selector';
import { updateWarning } from '../action/ui';

const mapStateToProps = state => ({
  warning: getWarning(state)
});

const mapDispatchToProps = { updateWarning };

export default connect(mapStateToProps, mapDispatchToProps)(Warning);
